import { type PropsWithChildren } from 'react'
// reason: export from third party lib not our own so no influence on its naming
// eslint-disable-next-line camelcase
import { ButtonBase, styled, unstable_memoTheme } from '@mui/material'
import { type BaseButtonProps } from '../../primitives/Button/BaseButton'

const CardAreaRoot = styled(ButtonBase, {
  name: 'DhlCardArea',
  slot: 'Root',
})(
  unstable_memoTheme(({ theme }) => ({
    display: 'block',
    width: '100%',
    textAlign: 'inherit',
    fontSize: 'inherit',
    alignItems: 'flex-start',
    justifyContent: 'start',

    ...theme.misc.createHoverOrActiveState({
      backgroundColor: theme.palette.action.focus,
    }),

    '&:focus-visible': {
      backgroundColor: theme.palette.action.focus,
      outline: theme.misc.borderStyle('pure.dark', 2),
      outlineOffset: `-${theme.misc.borderSize(2)}`,
    },
  }))
)

type Props = PropsWithChildren & BaseButtonProps

export const BaseCardArea = ({ children, ...rest }: Props) => (
  <CardAreaRoot component={rest.href ? 'a' : 'button'} {...rest}>
    {children}
  </CardAreaRoot>
)
